import type { PageContext } from 'vike/types';
import { getSiteName } from 'src/utils/ssrMeta';
import type { PageData } from './+data';

// vike-react renders this as <title> + <meta property="og:title">.
// Format: "Hotels in <Place> supporting <Org> | <Site>" when the
// search has a place filter; otherwise the org-name variant. Falls
// back to a site-aware default when org data is missing.
export default (pageContext: PageContext): string => {
   const siteName = getSiteName(pageContext);
   const { organization } = (pageContext.data ?? {}) as PageData;
   const orgName =
      organization?.beneficiary?.trim() ||
      organization?.nickname?.trim() ||
      organization?.name?.trim();

   // Vike exposes parsed query params at pageContext.urlParsed.search.
   const search = (pageContext as unknown as { urlParsed?: { search?: Record<string, string> } })
      .urlParsed?.search;
   const placeName = search?.place_name?.trim();

   if (orgName && placeName) return `Hotels in ${placeName} supporting ${orgName} | ${siteName}`;
   if (orgName) return `Hotels supporting ${orgName} | ${siteName}`;
   if (placeName) return `Hotels in ${placeName} | ${siteName}`;
   return `${siteName} — Book hotels at the same prices and fund your cause`;
};
